module.exports = __webpack_public_path__ + "img/MISSION.b2591bf9.png";